<template>
  <app-wrapper-div>{{ literalValue }}</app-wrapper-div>
</template>

<script>
export default {
  name: 'app-boolean-literal',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    literalValue() {
      return this.value ? this.$gettext('Ano') : this.$gettext('Ne')
    }
  }
}
</script>
